import videojs from 'video.js';

function formatTime(sec) {
	let h = Math.floor(sec / 3600),
		m = Math.floor(sec % 3600 / 60),
		s = Math.floor(sec % 60),
		t = [h, m, s];

	t.forEach((el, i, arr) => { 
		arr[i] = el < 10 ? '0' + el : el;
	});

	[h, m, s] = t;

	return `${h}:${m}:${s}`;
}

function sendRequest(url, options = {}) {
	let p = new Promise((resolve, reject) => {
		videojs.xhr(url, options, (err, resp) => {
			if (err) {
				reject(err);
			} else {
				const result = JSON.parse(resp.body);
				resolve(result);
			}
		});
	});
	return p;
}

function xmlData(url, options = {}) {
	let p = new Promise((resolve, reject) => {
		videojs.xhr(url, options, (err, resp) => {
			var parser = new DOMParser();
			err ? reject(err) :	resolve(utils.xmlToJson(parser.parseFromString(resp.body, "text/xml")));
		});
	});
	return p;
}

function isTouch() {
	return ('ontouchstart' in window);
}

function xmlToJson(xml) {
	var obj = {};

	if (xml.nodeType == 1) { // element

		if (xml.attributes.length > 0) {
			obj["@attributes"] = {};
				for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j);
				obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
				}
			}
		} else if (xml.nodeType == 3) { // text
			obj = xml.nodeValue;
		}

		// do children
		if (xml.hasChildNodes()) {
		for(var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i);
			var nodeName = item.nodeType == 3 ? '@val' : item.nodeName;
			if (typeof(obj[nodeName]) == "undefined") {
				obj[nodeName] = xmlToJson(item);
			} else {
				if (typeof(obj[nodeName].push) == "undefined") {
					var old = obj[nodeName];
					obj[nodeName] = [];
					obj[nodeName].push(old);
				}
				obj[nodeName].push(xmlToJson(item));
			}
		}
	}
	return obj;
}

var utils = {
	xmlData: xmlData,
	xmlToJson: xmlToJson,
	formatTime: formatTime,
	isTouch: isTouch,
	sendRequest: sendRequest
};

export default utils;